import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.show()
    this._onGlobalClick = this._onGlobalClick.bind(this)
    document.addEventListener("click", this._onGlobalClick)
  }

  disconnect() {
    document.removeEventListener("click", this._onGlobalClick)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  show() {
    this.element.classList.add("show")
    const delay = parseInt(this.element.getAttribute("data-bs-delay") || this.element.getAttribute("data-toast-delay") || "5000", 10)
    const autohide = this.element.getAttribute("data-bs-autohide") !== "false" && this.element.getAttribute("data-toast-autohide") !== "false"

    if (autohide) {
      this.timeout = window.setTimeout(() => this.close(), delay)
    }
  }

  close() {
    this.element.classList.remove("show")
  }

  _onGlobalClick(event) {
    const dismiss = event.target.closest('[data-bs-dismiss="toast"]') || event.target.closest('[data-toast-dismiss]')
    if (dismiss && this.element.contains(dismiss)) {
      event.preventDefault()
      this.close()
    }
  }
}
